'use client'

import { useEffect, useState } from 'react'

interface ScrollProgressBarProps {
  color?: string;
  height?: number;
}

export default function ScrollProgressBar({ 
  color = '#F5CC5C', 
  height = 3 
}: ScrollProgressBarProps) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const updateProgress = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      setProgress(scrollPercent);
    };

    window.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();

    return () => window.removeEventListener('scroll', updateProgress);
  }, []);

  return (
    <div 
      className="fixed top-0 left-0 w-full z-[60]"
      style={{ height }}
    >
      <div
        className="h-full transition-all duration-100 ease-out"
        style={{
          width: `${progress}%`,
          background: color,
          boxShadow: progress > 0 ? `0 0 10px ${color}40` : 'none'
        }}
      />
    </div>
  );
}
